import React from 'react'

import { Box, Grid } from '@material-ui/core'

//COMPONENTS
import MenuProduct from '../MenuProduct/MenuProduct'

//STYLE
import './styles.scss'

const MenuCategory = ({ products, category }) => {
  const { name } = category

  const activeProducts = products.filter(
    (product) => product.isActive === true && product.isDelete === false,
  )

  return (
    <Box marginBottom={5}>
      <h3 className="category-title">{name}</h3>
      <Grid container spacing={3}>
        {activeProducts.map((product) => (
          <Grid item sm={6} key={product.key}>
            <MenuProduct product={product} />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default MenuCategory
